export default __webpack_public_path__ + "static/media/doctor3.d5e96b3e.jpg";